import api from '@/api/index'
/* global wx */

export default {
	async setWxConfig({title = '云上乡村', desc = '云上乡村', imgUrl = 'https://vybbasevr.vyb.cn/3ad18070_360b_48d6_903f_201d25e4f2ad1639807990668'} = {}) {
		var ua = navigator.userAgent.toLowerCase();
		if (ua.match(/MicroMessenger/i) != "micromessenger") {
			return;
		}
		try {
			let href = window.location.href;
			let res = await api.content.getConfig({current_url: href})
			let {appId, timestamp, nonceStr, signature, jsApiList} = res.data;
			wx.config({appId, timestamp, nonceStr, signature, jsApiList,openTagList: ['wx-open-launch-weapp']});
			wx.ready(function () {
				let shareData = {
					title,
					link: href,
					desc,
					imgUrl,
				};
				wx.updateAppMessageShareData(shareData)
				wx.updateTimelineShareData(shareData)
			});
		} catch (e) {
			console.error(e)
		}
	}
}